import React, { Component } from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import Header from './components/Header';
import './App.css';

import Home from './views/Home';
import QuemSomos from './views/QuemSomos';
import ConsultoriaFinanceira from './views/ConsultoriaFinanceira';
import ConsultoriaEstrategica from './views/ConsultoriaEstrategica';
import Contato from './views/Contato';


class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Header />
          <Route exact path="/" component={Home} />
          <Route path="/quem-somos" component={QuemSomos} />
          <Route path="/consultoria-financeira" component={ConsultoriaFinanceira} />
          <Route path="/consultoria-estrategica" component={ConsultoriaEstrategica} />
          <Route path="/contato" component={Contato} />

        {/*
          
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/teachers" component={Teachers} />
          <Route path="/courses" component={Courses} />
        */}
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js